import { combineEpics } from 'redux-observable'
import { fetchCountriesEpic } from './fetchCountriesEpic'

export const countryEpics = combineEpics(fetchCountriesEpic)
